<template>
  <div class="study-experience coming-soon">
    <page-header title="我的学习心得" style="margin-bottom: 20px;" />
    <div class="options">
      <el-button type="primary">新增</el-button>
    </div>
    <ming-table :fields="column" :data="data" />

  </div>
</template>

<script setup>
import PageHeader from '@/components/PageHeader'
import { ref } from 'vue'
import { studyExperienceColumn } from './tableColumn'

const column = ref(studyExperienceColumn)
const data = ref([])
</script>

<style lang="scss" scoped>
  .options {
    margin-bottom: 20px;
  }
</style>
